module.exports = __webpack_public_path__ + "static/1-user-database-34e7b790f62c418032cfad75d8ab89bf.png";